import axios, { AxiosRequestConfig } from "axios";
import {
  GranularCatalogConfig,
  createGranularRequestConfig,
} from "@granular/fabric-catalog-helpers";
import { UnreadReportsCountResponse } from "./models";

const BASE_URL = "/api/document-service/report";

export const getUnreadReportsCount = async (
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig
): Promise<UnreadReportsCountResponse> => {
  const url = `${BASE_URL}/unread_count`;
  return await axios.get(
    url,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig })
  );
};
